<template>
  <div id="notice">
    <call />
    <top-bar title="お知らせ一覧" backUrl="/"/>
    <!-- main -->
    <main>
      <!-- nav bot -->
      <footer-app></footer-app>
      <!-- notice -->
      <section>
        <div class="l-main l-main--bg-border--pink">
          <div class="l-main__body">
            <ul class="c-list-notice" v-if="shopNews?.length > 0">
              <li v-for="(notice, index) in shopNews" :key="index" v-on:click="openModalDetail(notice.id)">
                <div class="c-list-notice__time">
                  <span v-if="notice.discloseAt">{{ formatDateTime(notice.discloseAt) }}</span>
                  <span class="c-list-notice__time_new" v-if="notice.discloseAt && isNew(new Date(notice.discloseAt))">NEW</span>
                </div>
                <div class="c-list-notice__title font-bold">
                  {{ notice.title }}
                </div>
              </li>
            </ul>
            <div class="c-list-notice__empty ml-17 mt-8" v-else>
              ただいま掲載中の情報はありません
            </div>
          </div>
        </div>
      </section>
      <modal :open="openModal" @close="() => {
        openModal = false;
        this.$router.push({ query: {} });
      }">
        <announce-detail :newsId="newsId" />
      </modal>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Footer from "../components/Footer.vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import { SHOP_KEY } from "../config/const.js";
import {
  getSCNews,
  getDetailCollection
} from "../store/firestore.js";
import Modal from "../components/Modal.vue";
import AnnounceDetail from "./AnnounceDetail.vue";
import TopBar from "../components/TopBar.vue";

export default Vue.extend({
  name: "AnnounceList",
  components: {
    'footer-app': Footer,
    Modal,
    AnnounceDetail,
    TopBar,
  },
  mixins: [Tenant],
  data() {
    return {
      shopName: "",
      shopNews: null,
      getDetailCollection: getDetailCollection,
      getSCNews: getSCNews,
      newsId: "",
      openModal: false,
    }
  },
  watch: {
    '$route.query': {
      handler: function (newVal) {
        if (!newVal.id) {
          this.openModal = false
          return;
        }
        this.newsId = newVal.id
        this.openModal = true
      },
      immediate: false
    }
  },
  created() {
    if(this.$route.query.id) {
      this.newsId = this.$route.query.id
      this.openModal = true
    }
    this.init();
  },
  mounted() {
    Common.initDom();
  },
  methods: {
    async init() {
      Common.vueInitFunc(this);
      this.getDataShop();
      this.loading = false;
    },
    async getDataShop() {
      let shop = await this.getDetailCollection(SHOP_KEY, this.SHOP_ID);
      this.shopNews = await this.getSCNews(this.SHOP_ID);
      this.shopName = shop.name;
    },
    openModalDetail(newsId) {
      this.$router.push({
        query: {
          id: newsId,
        }
      });
    },
  },
  beforeDestroy() {
    this.shopName= "";
    this.shopNews= null;
  }
});
</script>